interface PageHeaderProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
}

// Trading-related background images from Unsplash
const defaultBackgrounds = [
  "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1920&q=80", // Trading screens
  "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=1920&q=80", // Stock chart
  "https://images.unsplash.com/photo-1642790106117-e829e14a795f?w=1920&q=80", // Crypto trading
];

export function PageHeader({
  title,
  subtitle,
  backgroundImage,
}: PageHeaderProps) {
  // Use provided image or pick a default based on title hash
  const bgImage =
    backgroundImage ||
    defaultBackgrounds[Math.abs(title.length) % defaultBackgrounds.length];

  return (
    <div className="relative overflow-hidden mb-6 sm:mb-8">
      {/* Background image with blur and overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${bgImage})`,
          filter: "blur(2px)",
          transform: "scale(1.1)", // Prevent blur edge artifacts
        }}
      />
      {/* Dark overlay with gradient - lighter for better image visibility */}
      <div className="absolute inset-0 bg-gradient-to-r from-surface-950/70 via-surface-950/40 to-surface-950/25" />
      <div className="absolute inset-0 bg-gradient-to-t from-surface-950/80 via-transparent to-transparent" />

      {/* Content */}
      <div className="relative z-10 px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-12">
        <div>
          <h1 
            className="text-2xl sm:text-3xl lg:text-4xl font-bold page-header-title mb-2 animate-fade-in"
          >
            {title}
          </h1>
          {subtitle && (
            <p
              className="page-header-subtitle text-base sm:text-lg animate-fade-in"
              style={{ animationDelay: "100ms" }}
            >
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary-500/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-1/4 w-64 h-64 bg-accent-500/5 rounded-full blur-3xl pointer-events-none" />
    </div>
  );
}
